import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent, InputDatepickerComponent, SelectComponent, TextareaComponent } from './components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputErrorMessagePipe } from './components/pipes/input-error-message.pipe';
import { OrderedMultiselectComponent } from '@shared/form-input/components/ordered-multiselect/ordered-multiselect.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { InputAutocompleteComponent } from './components/input-autocomplete/input-autocomplete.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';


@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		MatFormFieldModule,
		MatSelectModule,
		MatAutocompleteModule
	],
	declarations: [
		TextareaComponent,
		InputComponent,
		SelectComponent,
		InputDatepickerComponent,
		OrderedMultiselectComponent,
		InputErrorMessagePipe,
		InputAutocompleteComponent,
	],
	exports: [
		TextareaComponent,
		InputComponent,
		SelectComponent,
		InputDatepickerComponent,
		OrderedMultiselectComponent,
		InputErrorMessagePipe,
		InputAutocompleteComponent
	],
})
export class FormInputModule {
}
